/**
 * Parse a JSON string without throwing.
 *
 * Returns `fallback` when the input is nullish or not valid JSON — guarding the
 * common crash where a corrupt / partially-written / schema-drifted value
 * (typically from `localStorage`) is parsed during render and takes the whole
 * component down with a `SyntaxError`.
 *
 * @example
 *   const settings = safeJsonParse(localStorage.getItem(key), {});
 */
export function safeJsonParse<T>(
  value: string | null | undefined,
  fallback: T
): T {
  if (value === null || value === undefined) return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
}
